import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addProjectAdmin } from "../api/add-project-admin";
import { projectQueries } from "../api/project.queries";
import { removeProjectAdmin } from "../api/remove-project-admin";

export function useAddProjectAdmin(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => addProjectAdmin(projectId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries(
        projectQueries.getProjectAdmin({ projectId }),
      );
    },
  });
}

export function useRemoveProjectAdmin(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => removeProjectAdmin(projectId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries(
        projectQueries.getProjectAdmin({ projectId }),
      );
    },
  });
}
